"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchButtonIcon = exports.VerticalDiv = exports.AccessCodeStyle = exports.ListItemStyle = exports.SingleSearchStyles = exports.categoricMenuSX = exports.MarginRightDiv = exports.PointsBox = exports.FullWidthSingleSearch = exports.StyledLayoutSkeleton = exports.MenuAvatarText = exports.LogoCell = exports.ContainerCell = exports.SecondaryListItemText = exports.StyledCultureCloudLogoLink = exports.StyledLogoImage = exports.StyledLogoLink = exports.HeaderTabSkeleton = exports.AvatarSkeleton = exports.StyledSkeleton = exports.iconButtonOverride = exports.tabFocusOverride = exports.buttonFocusOverride = exports.CancelButton = exports.LogoImage = exports.Logo = exports.HeaderAvatar = exports.SearchExpandHeaderCell = exports.HeaderCell = exports.HeaderInnerRow = exports.HeaderRow = exports.FullWidthDivider = exports.LogoutMenuItem = exports.ProfileMenuItem = exports.HeaderContainer = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var MenuItemLink_1 = __importDefault(require("../MenuItem/MenuItemLink"));
var colors_1 = require("../ThemeProvider/colors");
var Avatar_1 = __importDefault(require("../Avatar"));
var Button_1 = __importDefault(require("../Button"));
var Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
var Box_1 = __importDefault(require("../Box"));
var Divider_1 = __importDefault(require("../Divider"));
var ListItemText_1 = __importDefault(require("../ListItemText"));
var IconButton_1 = __importDefault(require("../IconButton"));
exports.HeaderContainer = (0, styled_1.default)('header')({
    minHeight: 72,
});
exports.ProfileMenuItem = (0, styled_1.default)(MenuItemLink_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n  margin-bottom: 8px;\n"], ["\n  font-size: 14px;\n  margin-bottom: 8px;\n"])));
exports.LogoutMenuItem = (0, styled_1.default)(MenuItemLink_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n"], ["\n  font-size: 14px;\n"])));
exports.FullWidthDivider = (0, styled_1.default)(Divider_1.default)({
    margin: '8px -8px',
});
exports.HeaderRow = (0, styled_1.default)('div', {
    shouldForwardProp: function (prop) { return !/secondary|slim/.test(String(prop)); },
})(function (_a) {
    var _b = _a.secondary, secondary = _b === void 0 ? false : _b, _c = _a.slim, slim = _c === void 0 ? false : _c;
    return "\n  background-color: ".concat(secondary ? colors_1.tannerGray[900] : '#fff', ";\n  box-shadow: ").concat(secondary || slim ? 'none' : '0px 1px 0px #C4C4C4', ";\n  color: ").concat(secondary ? '#fff' : 'inherit', ";\n  height: ").concat(secondary ? 56 : 72, "px;\n  position: relative;\n");
});
exports.HeaderInnerRow = styled_1.default.div(function (_a) {
    var _b = _a.centered, centered = _b === void 0 ? false : _b;
    return "\n  display: flex;\n  height: 100%;\n  align-items: ".concat(centered ? 'center' : 'inherit', ";\n  justify-content: ").concat(centered ? 'center' : 'space-between', ";\n  margin: 0 auto;\n  max-width: 960px;\n  padding: 0 8px; \n");
});
exports.HeaderCell = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
exports.SearchExpandHeaderCell = (0, styled_1.default)(exports.HeaderCell, {
    shouldForwardProp: function (prop) { return !/searchOpen|snipBorder/.test(String(prop)); },
})(function (_a) {
    var _b = _a.searchOpen, searchOpen = _b === void 0 ? false : _b, _c = _a.snipBorder, snipBorder = _c === void 0 ? false : _c;
    return "\n  align-self: center;\n  border-radius: 5px;\n  flex-grow: 0;\n  flex-shrink: 1;\n  margin-left: auto;\n  margin-right: 8px;\n  max-width: 500px;\n  transition: all 200ms;\n  ".concat(searchOpen
        ? "\n    background-color: ".concat(colors_1.tannerGray['800'], ";\n    flex-grow: 1;\n    margin-left: unset;\n  ")
        : '', "\n  ").concat(snipBorder
        ? "\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  "
        : '', "\n");
});
exports.HeaderAvatar = (0, styled_1.default)(Avatar_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: 8px;\n"], ["\n  margin-left: 8px;\n"])));
exports.Logo = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  padding: 0 96px 0 16px;\n"], ["\n  display: flex;\n  padding: 0 96px 0 16px;\n"])));
exports.LogoImage = styled_1.default.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
exports.CancelButton = (0, styled_1.default)(Button_1.default)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 500;\n"], ["\n  color: ", ";\n  font-weight: 500;\n"])), colors_1.tannerGray['400']);
var outlineColor = colors_1.tannerBlue['500'];
exports.buttonFocusOverride = {
    '&:focus-visible': {
        backgroundColor: colors_1.tannerGray['100'],
        outline: "3px solid ".concat(outlineColor),
        outlineOffset: '3px',
        borderRadius: '4px',
    },
};
exports.tabFocusOverride = {
    '&:focus-visible': {
        outline: "3px solid ".concat(outlineColor),
        outlineOffset: '-8px',
        borderRadius: '14px',
    },
};
exports.iconButtonOverride = {
    '&:focus-visible': {
        outline: "3px solid ".concat(colors_1.tannerBlue['500']),
        outlineOffset: '2px',
        backgroundColor: colors_1.tannerGray['900'],
    },
};
exports.StyledSkeleton = (0, styled_1.default)(Skeleton_1.default)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  height: 24px;\n  width: 80px;\n  margin-right: 12px;\n"], ["\n  height: 24px;\n  width: 80px;\n  margin-right: 12px;\n"])));
exports.AvatarSkeleton = (0, styled_1.default)(Skeleton_1.default)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  height: 32px;\n  width: 32px;\n"], ["\n  height: 32px;\n  width: 32px;\n"])));
exports.HeaderTabSkeleton = (0, styled_1.default)(Skeleton_1.default)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  height: 24px;\n  width: 50px;\n  color: ", ";\n"], ["\n  height: 24px;\n  width: 50px;\n  color: ", ";\n"])), colors_1.tannerWhite);
exports.StyledLogoLink = styled_1.default.a(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  height: 40px;\n"], ["\n  height: 40px;\n"])));
exports.StyledLogoImage = (0, styled_1.default)(exports.LogoImage)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  height: 40px;\n  max-width: 220px;\n  object-fit: contain;\n"], ["\n  height: 40px;\n  max-width: 220px;\n  object-fit: contain;\n"])));
exports.StyledCultureCloudLogoLink = styled_1.default.a(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\npadding-top: 8px;\n  '&:focus-visible': {\n    outline: 3px solid ", ",\n    outlineOffset: '4px',\n    borderRadius: '2px',\n  },\n"], ["\npadding-top: 8px;\n  '&:focus-visible': {\n    outline: 3px solid ", ",\n    outlineOffset: '4px',\n    borderRadius: '2px',\n  },\n"])), outlineColor);
exports.SecondaryListItemText = (0, styled_1.default)(ListItemText_1.default)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
exports.ContainerCell = (0, styled_1.default)(exports.HeaderCell)(function (_a) {
    var searchOpen = _a.searchOpen;
    return "\n    max-width: 800px;\n    width: ".concat(searchOpen ? '0px' : '100%', ";\n  ");
});
exports.LogoCell = (0, styled_1.default)(exports.HeaderCell)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  padding-right: 40px;\n"], ["\n  padding-right: 40px;\n"])));
exports.MenuAvatarText = styled_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  font-size: 14px;\n  margin-left: 8px;\n  font-weight: 700;\n"], ["\n  font-size: 14px;\n  margin-left: 8px;\n  font-weight: 700;\n"])));
exports.StyledLayoutSkeleton = (0, styled_1.default)(Skeleton_1.default)(function (_a) {
    var theme = _a.theme;
    return "\n    height: 24,\n    width: 80,\n    marginRight: ".concat(theme.spacing(2), ",\n  ");
});
exports.FullWidthSingleSearch = {
    width: '100%',
};
exports.PointsBox = (0, styled_1.default)(Box_1.default)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  font-weight: 500;\n"], ["\n  font-weight: 500;\n"])));
exports.MarginRightDiv = styled_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
exports.categoricMenuSX = {
    minWidth: '400px',
    maxHeight: '360px',
    padding: '0 8px 8px',
};
exports.SingleSearchStyles = {
    width: '100%',
    '.MuiAutocomplete-inputRoot': {
        color: colors_1.tannerGray['400'],
        padding: '1px',
    },
    '.MuiAutocomplete-clearIndicator': {
        color: colors_1.tannerGray['400'],
        ':hover': {
            color: colors_1.tannerGray['200'],
        },
    },
    '.MuiCircularProgress-colorPrimary': {
        color: colors_1.tannerGray['400'],
    },
};
exports.ListItemStyle = {
    color: colors_1.tannerBlack,
};
exports.AccessCodeStyle = __assign(__assign({}, exports.ListItemStyle), { paddingLeft: '8px' });
exports.VerticalDiv = styled_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0px 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0px 8px;\n"])));
exports.SearchButtonIcon = (0, styled_1.default)(IconButton_1.default)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  padding-right: 8px;\n"], ["\n  padding-right: 8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;
//# sourceMappingURL=styles.js.map